import React from 'react';
import './Skeleton.css';

export const Bone = ({ className = '', width, height, style, dark = false, round = false }) => (
  <span
    className={[
      'sk-bone',
      dark ? 'sk-bone--dark' : '',
      round ? 'sk-bone--round' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    style={{
      width: width || undefined,
      height: height || undefined,
      ...style,
    }}
    aria-hidden="true"
  />
);

export const BreadcrumbSkeleton = () => (
  <div className="cas-breadcrumb">
    <div className="cas-breadcrumb-left">
      <Bone width={28} height={28} round />
      <Bone width={180} height={14} />
    </div>
    <div className="cas-breadcrumb-right">
      <Bone width={72} height={28} round />
      <Bone width={36} height={36} round />
    </div>
  </div>
);

export const SidebarSkeleton = () => (
  <aside className="cas-sidebar" aria-hidden="true">
    <Bone className="cas-sidebar-logo sk-bone--dark" width={36} height={36} />
    <div className="cas-sidebar-nav">
      {[0, 1, 2, 3, 4].map((i) => (
        <Bone key={i} className="cas-sidebar-item sk-bone--dark" width={28} height={28} />
      ))}
    </div>
  </aside>
);

export const ToolsContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando herramientas">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={220} height={28} />
        <Bone width={320} height={14} />
      </div>
    </div>
    <div className="cas-tools-grid">
      {[0, 1, 2].map((i) => (
        <div key={i} className="cas-tool-card">
          <Bone width="55%" height={18} />
          <Bone className="cas-tool-preview" />
          <Bone width="90%" height={12} />
          <Bone width="70%" height={12} />
          <Bone width="40%" height={36} style={{ marginTop: 8, borderRadius: 10 }} />
        </div>
      ))}
    </div>
  </div>
);

export const DashboardContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando dashboard">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={240} height={28} />
        <Bone width={300} height={14} />
      </div>
      <Bone width={160} height={40} style={{ borderRadius: 10 }} />
    </div>
    <div className="cas-metrics">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="cas-metric-card">
          <Bone width="45%" height={12} />
          <Bone width="60%" height={28} />
          <Bone width="35%" height={10} />
        </div>
      ))}
    </div>
    <div className="cas-panels">
      <div className="cas-panel">
        <Bone width="40%" height={16} />
        <Bone className="cas-panel-chart" />
      </div>
      <div className="cas-panel">
        <Bone width="50%" height={16} />
        <Bone width="100%" height={14} />
        <Bone width="90%" height={14} />
        <Bone width="95%" height={14} />
        <Bone width="80%" height={14} />
      </div>
    </div>
  </div>
);

export const SimulationsContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando simulaciones">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={260} height={28} />
        <Bone width={280} height={14} />
      </div>
      <Bone width={180} height={40} style={{ borderRadius: 10 }} />
    </div>
    <div className="cas-table">
      <div className="cas-table-row">
        <Bone width="70%" height={12} />
        <Bone width="60%" height={12} />
        <Bone width="50%" height={12} />
        <Bone width="40%" height={12} />
      </div>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="cas-table-row">
          <Bone width="85%" height={16} />
          <Bone width="70%" height={14} />
          <Bone width="55%" height={14} />
          <Bone width={64} height={28} style={{ borderRadius: 8 }} />
        </div>
      ))}
    </div>
  </div>
);

export const ProjectsContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando proyectos">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={220} height={28} />
        <Bone width={260} height={14} />
      </div>
      <Bone width={160} height={40} style={{ borderRadius: 10 }} />
    </div>
    <div className="cas-panels" style={{ marginBottom: 20 }}>
      <div className="cas-panel" style={{ minHeight: 180 }}>
        <Bone width="35%" height={14} />
        <Bone className="cas-panel-chart" style={{ minHeight: 120 }} />
      </div>
      <div className="cas-panel" style={{ minHeight: 180 }}>
        <Bone width="40%" height={14} />
        <Bone className="cas-panel-chart" style={{ minHeight: 120 }} />
      </div>
    </div>
    <div className="cas-table">
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="cas-table-row">
          <Bone width="80%" height={16} />
          <Bone width="60%" height={14} />
          <Bone width="50%" height={14} />
          <Bone width={72} height={28} style={{ borderRadius: 8 }} />
        </div>
      ))}
    </div>
  </div>
);

export const ProfileContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando perfil">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={160} height={28} />
        <Bone width={240} height={14} />
      </div>
    </div>
    <div className="cas-form">
      <div className="cas-form-row">
        <div className="cas-field">
          <Bone width={80} height={12} />
          <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
        </div>
        <div className="cas-field">
          <Bone width={90} height={12} />
          <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
        </div>
      </div>
      <div className="cas-field">
        <Bone width={70} height={12} />
        <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
      </div>
      <div className="cas-field">
        <Bone width={100} height={12} />
        <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
      </div>
      <Bone width={140} height={40} style={{ borderRadius: 10, marginTop: 8 }} />
    </div>
  </div>
);

export const TableContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando datos">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={200} height={28} />
        <Bone width={260} height={14} />
      </div>
    </div>
    <div className="cas-table">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="cas-table-row">
          <Bone width="75%" height={16} />
          <Bone width="55%" height={14} />
          <Bone width="45%" height={14} />
          <Bone width={70} height={28} style={{ borderRadius: 8 }} />
        </div>
      ))}
    </div>
  </div>
);

export const PanelContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando panel">
    <div className="cas-content-header">
      <div className="cas-title-block">
        <Bone width={180} height={28} />
        <Bone width={240} height={14} />
      </div>
    </div>
    <div className="cas-panels">
      <div className="cas-panel">
        <Bone width="40%" height={16} />
        <Bone className="cas-panel-chart" />
      </div>
      <div className="cas-panel">
        <Bone width="45%" height={16} />
        <Bone width="100%" height={14} />
        <Bone width="92%" height={14} />
        <Bone width="88%" height={14} />
        <Bone width="70%" height={40} style={{ borderRadius: 10, marginTop: 12 }} />
      </div>
    </div>
  </div>
);

export const SimulatorContentSkeleton = () => (
  <div className="cas-content" role="status" aria-busy="true" aria-label="Cargando simulador">
    <div className="cas-simulator">
      <div className="cas-simulator-tabs">
        {[0, 1, 2, 3, 4].map((i) => (
          <Bone key={i} width={110} height={36} style={{ borderRadius: 10 }} />
        ))}
      </div>
      <div className="cas-simulator-body">
        <div className="cas-simulator-col">
          <Bone width="50%" height={18} />
          <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
          <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
          <Bone width="100%" height={40} style={{ borderRadius: 10 }} />
          <Bone width="70%" height={40} style={{ borderRadius: 10 }} />
        </div>
        <div className="cas-simulator-col">
          <Bone width="40%" height={18} />
          <Bone style={{ flex: 1, minHeight: 220, borderRadius: 12 }} />
        </div>
      </div>
    </div>
  </div>
);

const CONTENT_BY_VARIANT = {
  tools: ToolsContentSkeleton,
  dashboard: DashboardContentSkeleton,
  simulations: SimulationsContentSkeleton,
  projects: ProjectsContentSkeleton,
  profile: ProfileContentSkeleton,
  table: TableContentSkeleton,
  panel: PanelContentSkeleton,
  simulator: SimulatorContentSkeleton,
};

/**
 * Shell completo (sidebar + breadcrumb + contenido) para Suspense / auth boot.
 */
export const ClientAreaSkeleton = ({ variant = 'tools' }) => {
  const Content = CONTENT_BY_VARIANT[variant] || ToolsContentSkeleton;

  return (
    <div className="client-area-skeleton" role="status" aria-busy="true">
      <SidebarSkeleton />
      <div className="cas-main">
        <BreadcrumbSkeleton />
        <Content />
      </div>
    </div>
  );
};

export default ClientAreaSkeleton;
